// Components==============
import React from 'react';
import './Container.module.scss';
// =========================

export default function Container({
  children,
  padding,
  maxWidth,
  marginBottom,
}: {
  children: React.ReactNode;
  padding?: boolean;
  maxWidth?: number;
  marginBottom?: string;
}) {
  return (
    <div
      styleName={`container ${padding ? 'padding' : ''}`}
      style={{
        maxWidth,
        marginLeft: maxWidth ? 'auto' : '',
        marginRight: maxWidth ? 'auto' : '',
        marginBottom,
      }}
    >
      {children}
    </div>
  );
}
